import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';
const Twitter: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 5.62606C21.0326 5.94456 20.2615 6.15906 19.4522 6.25575C20.2786 5.76094 20.9131 4.97687 21.2113 4.0425C20.4386 4.50075 19.5822 4.83387 18.6706 5.01344C17.9418 4.23587 16.901 3.75 15.7505 3.75C13.1676 3.75 11.2696 6.15987 11.8529 8.66156C8.529 8.495 5.58125 6.9025 3.60769 4.48206C2.55956 6.28012 3.06412 8.63231 4.84512 9.82343C4.19025 9.80231 3.57275 9.62275 3.03406 9.32293C2.99019 11.1762 4.31862 12.9101 6.24262 13.2961C5.67956 13.4488 5.06287 13.4846 4.43562 13.3643C4.94425 14.9536 6.42137 16.1097 8.17312 16.1422C6.49125 17.4609 4.37225 18.05 2.25 17.7997C4.02044 18.9348 6.124 19.597 8.38275 19.597C15.8106 19.597 20.0072 13.3237 19.7537 7.69712C20.5353 7.13243 21.2137 6.428 21.75 5.62606Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Twitter;
